/**
 * types
 *
 * @Author  Carey.zhou
 * @DATE    create on 2019/9/16
 * @DESC
 */

export const SET_QUERY_PARAM = 'SET_QUERY_PARAM' // 设置查询参数
export const CLEAR_QUERY_PARA = 'CLEAR_QUERY_PARA' // 清楚查询的参数
